import { PDFViewer } from "@react-pdf/renderer";

export function Viewer({ children }) {
  const root = document.getElementById("root");
  root.style.overflow = "hidden";
  return (
    <div style={{ width: "100vw", height: "100vh" }}>
      <PDFViewer width="100%" height="100%">
        {children}
      </PDFViewer>
    </div>
  );
}
